// The Park Gentlemen catalog.
//
// THIS ARRAY IS THE ONLY PLACE THE HUB READS FROM. To add a game: append an
// entry here, drop its page in the project root (e.g. `tilt.html`), and add
// that page to `build.rollupOptions.input` in vite.config.js. The hub picks it
// up automatically — no other file needs touching.
//
// status:
//   'playable' — has an `href`; the card is a live link.
//   'soon'     — greyed out, not clickable, no href needed. These render as
//                PLACEHOLDERS, not as promises: nobody is building them yet, so
//                the card must not imply active development or a release. Rename
//                or delete them freely; give one an `href` and it goes live.
//
// art: key into ART in ./art.js. Only shipped games get representational
// artwork; unbuilt ones get an abstract placeholder treatment on purpose —
// a thumbnail that looks like a screenshot of a game that doesn't exist yet
// would be a lie to anyone browsing.

export const GAMES = [
  {
    id: 'skyline',
    title: 'Skyline',
    genre: 'Runner / Platformer',
    tagline: 'Sprint the conveyor belts, run the walls, survive the playground.',
    blurb:
      '1,000 hand-validated levels across 10 seasons. Wall runs, climb walls, ' +
      'tube slides, and a floor that will not stop moving.',
    status: 'playable',
    href: 'skyline.html',
    art: 'skyline',
    accent: '#59e8a8',
    // Reads live progress out of the save mirror and renders it on the card.
    progress: 'skyline',
  },

  {
    id: 'dragonscape',
    title: 'DragonScape',
    genre: 'Survival / Last man standing',
    tagline: 'The dragons are eating the island. Outlast everyone on it.',
    blurb:
      'A 150×150 block island, three dragons carving it into trenches, and ' +
      'seven rivals. Double jump and grappling hook on cooldowns — be the ' +
      'last gentleman standing.',
    status: 'playable',
    href: 'dragonscape.html',
    art: 'dragonscape',
    accent: '#ff9a3c',
  },

  {
    id: 'racemadness',
    title: 'RaceMadness',
    genre: 'Racing / Car combat',
    tagline: 'Race it or waste it.',
    blurb:
      'Eight stunt tracks and a grid full of rivals. Flip off mega ramps to ' +
      'charge your power, ram rivals to pieces, and thread the gold rings ' +
      'to rebuild your car mid-race.',
    status: 'playable',
    href: 'racemadness.html',
    art: 'racemadness',
    accent: '#ff5c44',
  },

  {
    id: 'skyplayground',
    title: 'Sky Playground',
    genre: 'Battle royale / Arena',
    tagline: 'A dragon is eating the playground. Be the last one on it.',
    blurb:
      'Melee battle royale on a platform floating in the clouds. The dragon ' +
      'circles and tears the ground away until only one player is left standing.',
    status: 'playable',
    // Lives in its own repo (../PG games) and is mounted here — served from disk
    // in dev, copied into dist/ at build. See tools/external-games.mjs.
    href: 'skyplayground/index.html',
    art: 'skyplayground',
    accent: '#ffd34d',
  },

  // ---- Example placeholders — rename, re-theme, or delete freely -----------
  {
    id: 'tilt',
    title: 'Tilt',
    genre: 'Balance / Puzzle',
    tagline: 'Steer the whole park instead of the player.',
    status: 'soon',
    art: 'placeholder',
    accent: '#ffd97a',
  },
  {
    id: 'splash',
    title: 'Splash',
    genre: 'Water park / Time trial',
    tagline: 'Flumes, wave pools, and very poor safety standards.',
    status: 'soon',
    art: 'placeholder',
    accent: '#58a8d8',
  },
  {
    id: 'coaster',
    title: 'Coaster',
    genre: 'Rails / Score attack',
    tagline: 'Build the track under yourself while riding it.',
    status: 'soon',
    art: 'placeholder',
    accent: '#ff6b6b',
  },
];

export const playableCount = () => GAMES.filter((g) => g.status === 'playable').length;
